//
//  bball
//  theme.js
//
//  © 2021 Blake Ball

export const lightTheme = {
  header: '#7dd56f',
  body: '#E2E2E2',
  text: '#363537',
  active: '#FFFFFF',
  toggleBorder: '#363537',
  toggleBackground: '#E2E2E2',
};

export const darkTheme = {
  header: '#24292e',
  body: '#363537',
  text: '#FAFAFA',
  active: '#7dd56f',
  toggleBorder: '#7dd56f',
  toggleBackground: '#363537',
};
